var styles = {"box":"ToolbarWrapper_box_8ht3f_1","sm":"ToolbarWrapper_sm_8ht3f_6","mobile-md":"ToolbarWrapper_mobile-md_8ht3f_14"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
